module.exports = __webpack_public_path__ + "fonts/NeueHaasGroteskText-55Roman.7f9e0a2.ttf";